import { TileLayout } from "@progress/kendo-react-all";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SBAComboBox } from "../UiComponents/SBADropDown";
import {
    DDQStatus,
    IndexPerformance,
    InvestedAssetExposures,
    InvestedAssetPerformance,
    MyRecentActivities,
    MyTasks,
    UpcomingMeetings,
    InvestedAUM,
    ManagerAlerts,
    ClientPerformance
} from "./investmentViewWidgets";
import { getCustomSettings } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";
import { useEffect } from "react";
import {getStrategy} from "../actions/assetDetailsActions";

const InvestmentView = () => {

    return <>
     <div className="row m-0 ">
        <div className="col-md-8">
          <h2 className="fs-5 fw-semibold">Overview</h2>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center gap-2">
            <select className="form-select" aria-label="Default select example" disabled>
              <option selected>Default Style</option>
              <option value="1">Dashboard Style 2</option>
              <option value="3">Dashboard Style 3</option>
              <option value="4">Dashboard Style 4</option>
              <option value="4">Create New Dashboard</option>
            </select>
            {/* <div className="dropdown">
              <a className="dropdown-toggle setting" href="#" role="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img src={Settingicon} title="Customize Dashboard" alt=""/>
              </a>
              {/* <ul className="dropdown-menu">
                  <li><a className="dropdown-item" >Customize Dashboard</a></li>
              </ul> */}
            {/*</div> */}
          </div>
        </div>
      </div>
    <div className="bg-white p-2">
        <InvestmentViewWidgets></InvestmentViewWidgets>
    </div></>
};

const InvestmentViewWidgets = () => {
    const [StrategyDD, setStrategyDD] = useState([]);
    const [selectedStrategy, setSelectedStrategy] = useState(null);
    const [showAllExposure, setShowAllExposure] = useState(false);
    const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
    const dispatch = useDispatch();

    const Strategy = Gstate.strategy.strategy;
    useEffect(() => {
        if(Strategy?.length > 0){
            const filteredList = Strategy?.filter((item) => item.ClassificationValue !== "--Please Select--")
            const updatedDD = [
                {
                    ClassificationId: 0,
                    ClassificationValue: "All",
                    ParentClassification: 14
                },...filteredList
            ]
            setStrategyDD(updatedDD);
        }
    },[Strategy]);

    useEffect(() => {
        if(StrategyDD?.length > 0){
            setSelectedStrategy(StrategyDD[0]);
        }
    },[StrategyDD]);

    useEffect(() => {
        dispatch(getStrategy());
      }, []);
    const [data, setData] = useState([
        { col: 1, colSpan: 1, rowSpan: 2 },
        { col: 2, colSpan: 1, rowSpan: 2 },
        { col: 3, colSpan: 1, rowSpan: 2 },
        { col: 1, colSpan: 1, rowSpan: 2 },
        { col: 2, colSpan: 1, rowSpan: 2 },
        { col: 3, colSpan: 1, rowSpan: 2 },
        { col: 1, colSpan: 1, rowSpan: 2 },
        { col: 2, colSpan: 1, rowSpan: 2 },
        { col: 3, colSpan: 1, rowSpan: 2 },
        { col: 1, colSpan: 1, rowSpan: 2 },
        { col: 2, colSpan: 1, rowSpan: 2 },
        { col: 3, colSpan: 1, rowSpan: 2 },
        { col: 1, colSpan: 1, rowSpan: 2 }
    ]);
    const [bIndex, setBIndex] = useState(0);
    const [titeCollections,setTitleCollection]=useState([]);
    
    const RecentActivitiesButtons = ['My', 'All'];
    useEffect(()=>{
        getHomeDashBoardSettings();
    },[])
    const raButtonClick = (index) => {
        setBIndex(index);
    }
    const strategyDropdownChange = (e) => {
        if (e.value) {
            setSelectedStrategy(e.value);
        }
  };
    const tiles = [
        {
            header: <div className="header-container d-flex align-items-center justify-content-between" style={{ height: "20px" }}>
            <b className="text-nowrap">Invested Asset Performance</b>
            
            <div className="d-flex align-items-center ms-auto">
                {/* <label className="label me-2">Strategy</label> */}
                <SBAComboBox
                    textField={"ClassificationValue"}
                    valueField={"ClassificationId"}
                    data={StrategyDD}
                    value ={selectedStrategy}
                    onChange={strategyDropdownChange}
                />
            </div>
        </div>,
            body: <><InvestedAssetPerformance assetTypeId={selectedStrategy?.ClassificationId}/></>,
            resizable: false,
            componentID:'C1'
        },
        {
            header: <div className="header-container"><b>Index Performance</b></div>,
            body: <><IndexPerformance /></>,
            resizable: false,
            componentID:'C2'

        },
        {
            header: <div className="header-container" style={{ height: "20px" }}>
                <b>{bIndex === 0 ? "My " : "All "}Recent Activities</b>
                <div className="button-container ms-auto">
                    {RecentActivitiesButtons.map((name, index) => (
                        <button
                            key={index}
                            className={bIndex === index ? "selected-non-gappable-button p-2" : "non-gappable-button p-2"}
                            onClick={() => raButtonClick(index)}>
                            {name}
                        </button>
                    ))}
                </div>
            </div>,
            body: <><MyRecentActivities bIndex={bIndex} /></>,
            resizable: false,
            componentID:'C3'

        },
        {
            header: <div className="header-container">
                <b>Invested Asset Exposures</b>
                <div className="button-container ms-auto">
                    <input 
                        type="Checkbox" 
                        className="mx-2"  
                        checked={showAllExposure} 
                        onChange={(e)=>{setShowAllExposure(!showAllExposure)}} 
                    />
                    Show All
                </div>
                </div>,
            body: <><InvestedAssetExposures showAll={showAllExposure}/></>,
            resizable: false,
            componentID:'C4'

        },
        {
            header: <div className="header-container"><b>Invested AUM</b></div>,
            body: <><InvestedAUM /></>,
            resizable: false,
            componentID:'C5'

        },
       
        {
            header: <div className="header-container"><b>Upcoming Meetings</b></div>,
            body: <><UpcomingMeetings /></>,
            resizable: false,
            componentID:'C6'

        },
        {
            header: <div className="header-container"><b>DDQ Status</b></div>,
            body: <><DDQStatus /></>,
            resizable: false,
            componentID:'C7'

        },
       
        {
            header: <div className="header-container"><b>Manager Alerts</b></div>,
            body: <><ManagerAlerts /></>,
            resizable: false,
            componentID:'C8'

        },
        {
            header: <div className="header-container"><b>Investment Tasks</b></div>,
            body: <><MyTasks /></>,
            resizable: false,
            componentID:'C9'

        },
        {
            header: <div className="header-container"><b>Client Performance</b></div>,
            body: <><ClientPerformance /></>,
            resizable: false,
            componentID:'C10'

        }
    ];


    const handleReposition = (e) => {
        setData(e.value);
    }
    const getHomeDashBoardSettings = () => {
        sbaAxios({ url: getCustomSettings + "1029" }).then(res => {
            setTitleCollection(val=>JSON.parse(res?.CustomSettingsValue || '[]'));
            JSON.parse(res?.CustomFilterValue || '{}')
        }).catch(err => {
          console.log(err, 'Error Occured While retriving the User Setting')
        })
      };
    const filteredSortedTitles=titeCollections.map((item)=>{
        const tile= tiles.find(tile=>tile.componentID==item.componentId)
        tile.SortOrder=item.SortOrder
        return tile;
    }).sort((a,b)=>a.SortOrder-b.SortOrder);
    console.log(filteredSortedTitles)
    return (
        <div id="assettile">
            <TileLayout
            className="bg-white"
            columns={3}
            rowHeight={255}
            positions={data}
            gap={{ rows: 10, columns: 10 }}
            items={filteredSortedTitles}
            onReposition={handleReposition}
        />
        </div>
    );
}
export default InvestmentView